import { createGlobalStyle } from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';

const BaseGlobalStyle = createGlobalStyle<{ theme: 'light' | 'dark' }>`
  :root {
    --primary: #FF7F50; /* Coral highlight */
    --white: #FFFFFF;
    --light-gray: #F5F5F7;
    --dark-gray: #1D1D1F;
    --black: #000000;
    --silver-black: #121212;
    
    /* Dynamic theme colors */
    --background: ${(props) =>
      props.theme === 'light' ? 'var(--white)' : 'var(--silver-black)'};
    --text: ${(props) =>
      props.theme === 'light' ? 'var(--dark-gray)' : 'var(--white)'};
    --nav-background: ${(props) =>
      props.theme === 'light'
        ? 'rgba(255, 255, 255, 0.8)'
        : 'rgba(18, 18, 18, 0.8)'};
    --card-background: ${(props) =>
      props.theme === 'light' ? 'var(--white)' : 'var(--dark-gray)'};
    --subtle-text: ${(props) =>
      props.theme === 'light' ? '#86868b' : '#a1a1a6'};
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  
  html, body {
    overflow-x: hidden;
    scroll-behavior: smooth;
  }
  
  body {
    background-color: var(--background);
    color: var(--text);
    transition: background-color 0.5s ease, color 0.5s ease;
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }
  
  button {
    cursor: pointer;
    border: none;
    outline: none;
  }
`;

const GlobalStyle: React.FC = () => {
  const { theme } = useTheme();
  return <BaseGlobalStyle theme={theme as any} />;
};

export default GlobalStyle;
